import { useRepositoryQuery } from '@mews-commander/data-access';
import { FormSelectField, FormSelectFieldProps } from '@mews/framework';
import { DropdownItem } from '@optimus-web/core';
import { parseUserNotificationToFormData } from '../useConfigureSsoPanelForm';

export type SsoNotificationEmailFieldProps = Pick<
    FormSelectFieldProps,
    'name' | 'label' | 'helper' | 'size' | 'required'
>;

export const SsoNotificationEmailField = (props: SsoNotificationEmailFieldProps) => {
    const { data, isPending } = useRepositoryQuery('ssoConnection', 'getUserNotifications', {});
    return (
        <FormSelectField loader={isPending} multiselect virtualized {...props}>
            {data?.userNotifications?.map((user) => (
                <DropdownItem
                    key={user.userId}
                    label={user.userEmailAddress}
                    value={parseUserNotificationToFormData(user)}
                />
            ))}
        </FormSelectField>
    );
};
